import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { API_URL } from "@/shared"
import { showNotification } from "@mantine/notifications"

export const useWorkshops = (filters?: { medico_id?: string; clinica_id?: string }) => {
  return useQuery({
    queryKey: ["medical-education-workshops", filters],
    queryFn: async () => {
      try {
        const response = await axios.get(`${API_URL}/medical-education/workshops`, { params: filters })
        return response.data.data
      } catch (err) {
        console.error("Error getting workshops", err)
        showNotification({ title: "Error al obtener talleres", message: "No se pudieron cargar los talleres. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    }
  })
}

export const useCreateWorkshop = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (workshopData: any) => {
      try {
        const response = await axios.post(`${API_URL}/medical-education/workshops`, workshopData)
        showNotification({ title: "Taller agregado", message: "El taller ha sido agregado exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error creating workshop", err)
        showNotification({ title: "Error al agregar taller", message: "No se pudo agregar el taller. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-workshops"] })
    }
  })
}

export const useUpdateWorkshop = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, workshopData }: { id: string; workshopData: any }) => {
      try {
        const response = await axios.put(`${API_URL}/medical-education/workshops/${id}`, workshopData)
        showNotification({ title: "Taller actualizado", message: "El taller ha sido actualizado exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error updating workshop", err)
        showNotification({ title: "Error al actualizar taller", message: "No se pudo actualizar el taller. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-workshops"] })
    }
  })
}

export const useDeleteWorkshop = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`${API_URL}/medical-education/workshops/${id}`)
        showNotification({ title: "Taller eliminado", message: "El taller ha sido eliminado exitosamente.", color: "green" })
        return response.data
      } catch (err) {
        console.error("Error deleting workshop", err)
        showNotification({ title: "Error al eliminar taller", message: "No se pudo eliminar el taller. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-workshops"] })
    }
  })
}
